import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'GrowthBar',
  mounted: function mounted() {
    var _this = this;

    if (this.vip.score() > 0) {
      setTimeout(function () {
        $(_this.$el).find('#progress_svg').attr('stroke-dasharray', _this.vip.ratio() * 280 + ' 280');
      }, 100);
    }
  }
};